import { render } from "./LitigationProcessView.vue?vue&type=template&id=40bbf42e"
const script = {}

import exportComponent from "/Users/baojian/Documents/coipor/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__